// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qH94F","footer":"styles_footer__1SJ-E"};